<template>
  <div>
    <v-dialog v-model="dialog" :width="width" persistent>
      <template v-slot:activator="{ on }">
        <slot name="activator" :showDialog="showDialog"></slot>
      </template>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{ title }}</v-card-title>
        <v-card-text class="pt-6">
          <slot name="body"></slot>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <div class="flex-grow-1"></div>
          <v-btn color="secondary" text @click="dialog = false" :disabled="saving">{{ cancelButtonText }}</v-btn>
          <v-btn v-if="submitButtonText" color="primary" text @click="submit()" :disabled="saving" :loading="saving">{{ submitButtonText }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { is, clone } from 'ramda'

export default {
  name: 'confirmation',
  data () {
    return {
      saving: false,
      dialog: false,
    }
  },
  props: {
    width: {
      type: String,
      required: false,
      default: '500',
    },
    entity: {
      type: Object,
      required: false,
    },
    title: {
      type: String,
      required: false,
      default: 'Confirmation',
    },
    submitHandler: {
      type: Function,
      required: false,
    },
    cancelButtonText: {
      type: String,
      required: false,
      default () {
        return this.$t('global-terms.cancel')
      },
    },
    submitButtonText: {
      type: String,
      required: false,
      default () {
        return this.$t('global-terms.confirm')
      },
    },
  },
  methods: {
    is,
    showDialog () {
      this.dialog = true
    },
    submit () {
      if (is(Function, this.submitHandler)) {
        this.saving = true
        return this.submitHandler(clone(this.entity) || null)
          .then(() => {
            this.dialog = false
            this.saving = false
          })
      }
    },
  },
}
</script>
